import React from "react";
import { OptionCard, Textarea } from "components";
import { DIFFICULTY } from "./options";
import { Bars, EditIcon } from "../icons";

const DifficultyField = ({ value, otherText, onChange, onOtherText }) => (
  <div className="cg-field">
    <span className="cg-field-label">Difficulty</span>
    <div className="cg-opt-grid">
      {DIFFICULTY.map((o) => (
        <OptionCard
          key={o.id}
          name={o.name}
          description={o.desc}
          icon={<Bars level={o.level} />}
          iconColor={o.iconColor}
          selected={value === o.id}
          onSelect={() => onChange(o.id)}
        />
      ))}
    </div>
    <OptionCard
      layout="row"
      name="Tell us about your group"
      description="Describe your crowd and we'll tune the difficulty to them."
      icon={<EditIcon size={22} />}
      selected={value === "other"}
      onSelect={() => onChange("other")}
    />
    {value === "other" && (
      <Textarea
        aria-label="Tell us about your group"
        autoFocus
        rows={3}
        placeholder="A class of 7-year-olds? Casual trivia fans? Former Quiz-Bowl champions? Tell us and we'll tailor it to your expertise."
        value={otherText}
        maxLength={200}
        onChange={(e) => onOtherText(e.target.value)}
      />
    )}
  </div>
);

export default DifficultyField;
